<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1" :tbody-tr-class="rowClass">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
<!--      <template v-slot:cell(index)="data">-->
<!--        {{ data.index + 1 }}-->
<!--      </template>-->
      <template v-slot:cell(trainingCompanyName)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.trainingCompanyName)">{{ data.item.trainingCompanyName }}</div>
      </template>
      <template v-slot:cell(trainingScore)="data">
        <div>{{ Number(data.item.trainingScore).toFixed(2) }}</div>
      </template>

      <template v-slot:cell(attachList)="data">
        <div style="color: #4caedc" v-for="(file,index) in data.item.attachList" @click="$viewAttach(file)">{{ file.name }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "lamsPresentList",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'trainingCompanyName', label: '公司名称', width: '140px'},
        {key: 'trainingDeptName', label: '部门名称', width: '120px'},
        {key: 'trainingPostName', label: '岗位名称', width: '120px'},
        {key: 'trainingUserName', label: '姓名', width: '120px'},
        {key: 'trainingScore', label: '培训成绩', width: '120px'},
        {key: 'attachList', label: '附件', width: '120px'},
      ],
      items: [],
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value));
        }
        return total
      }, new Decimal(0)).toFixed(2, Decimal.ROUND_HALF_UP);
    },
    sumNum2(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(0, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    sumNum3(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(0, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>
::v-deep .row-center td {
  vertical-align: middle;
}
</style>
